import {Component, Injector, OnInit} from "@angular/core";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {FormGroup} from "@angular/forms";
import {ParameterService} from "../../_services/parameter.service";
import {NewCertificationService} from "./services/new-certification.service";
import {AssociationService} from "../associactions/services/association.service";

@Component({
    selector: 'app-new-certification-domain-view',
    templateUrl: './new-certification-domain-view.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class NewCertificationDomainViewComponent extends BaseComponentDirective implements OnInit {
    public form: FormGroup;

    attendanceTypes:any = {};
    associations: any[] = [];
    certDomains: any[] = [];
    certification: any = null;
    domainId: number = null;
    domain: any = null;
    associationName = '';

    constructor(
        injector: Injector,
        private parameterService: ParameterService,
        private certificationService: NewCertificationService,
        private associationService: AssociationService
    ) {
        super(injector);
    }


    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.attendanceTypes = await this.parameterService.getParameterByName("ATTENDANCE_TYPE");
        this.associations = await this.associationService.getAllNoPaging();
        this.certification = await this.certificationService.getById(this.activatedRoute.snapshot.params.certificationId);
        this.certDomains = await this.certificationService.getDomainsByCertificationId(this.certification.id);
        this.domainId = this.activatedRoute.snapshot.params.domainId;
        const association = this.associations.find(a => a.id == this.certification.association.id);
        this.associationName = association ? association.providerName : '';

        const domains = this.certDomains as any[];

        this.domain = domains.find(d => d.id == this.domainId);

    }

    goEdit(certificationId: number, domainId: number) {
        this.router.navigate([`/office/new-certification/detail/${this.certification.id}/domain/${domainId}/edit`]).then();
    }


}
